import React from "react";
import Header from "@/components/dn/Header";
import Hero from "@/components/dn/Hero";
import InvitationMarquee from "@/components/dn/InvitationMarquee";
import WhoItsFor from "@/components/dn/WhoItsFor";
import ThreePillars from "@/components/dn/ThreePillars";
import LayersOfOnion from "@/components/dn/LayersOfOnion";
import Roundtable from "@/components/dn/Roundtable";
import HowItWorks from "@/components/dn/HowItWorks";
import Membership from "@/components/dn/Membership";
import CodeOfConduct from "@/components/dn/CodeOfConduct";
import FAQ from "@/components/dn/FAQ";
import FinalCTA from "@/components/dn/FinalCTA";
import Footer from "@/components/dn/Footer";

const Home = () => {
    return (
        <main
            data-testid="home-page"
            className="relative min-h-screen bg-[#0a0c27] text-[#f6f1e1] font-body overflow-x-hidden"
        >
            {/* Global starfield ambient layer */}
            <div
                className="fixed inset-0 pointer-events-none dn-stars opacity-60"
                aria-hidden="true"
            />
            <div className="relative">
                <Header />
                <Hero />
                <InvitationMarquee />
                <WhoItsFor />
                <ThreePillars />
                <LayersOfOnion />
                <Roundtable />
                <HowItWorks />
                <Membership />
                <CodeOfConduct />
                <FAQ />
                <FinalCTA />
                <Footer />
            </div>
        </main>
    );
};

export default Home;
